import { render, staticRenderFns } from "./conductedTraining.vue?vue&type=template&id=b1922ba2&scoped=true"
import script from "./conductedTraining.vue?vue&type=script&lang=js"
export * from "./conductedTraining.vue?vue&type=script&lang=js"
import style0 from "./conductedTraining.vue?vue&type=style&index=0&id=b1922ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1922ba2",
  null
  
)

export default component.exports